














































































































































import { RouteRecord } from 'vue-router'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  get routeTitle (): string {
    return this.$route.meta.title
  }

  get routes (): Array<RouteRecord> {
    return (this.$parent && this.$parent.$route && this.$parent.$route.matched) || []
  }
}
